/**
 * Created by yoavp on 11/20/2014.
 */
define(function (require) {
    "use strict";

    var KPSnippetView = require("connection-views/KPsTab/KPSnippetView");
    var NoResultsView = require("connection-views/KPsTab/NoResultsView");
    var Template = require("connection-templates/KPsTab/KPsSnippetsCompositeView.tmpl");

    var KPsSnippetsCompositeView;
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        KPsSnippetsCompositeView = Marionette.CompositeView.extend({
            itemView: KPSnippetView,
            template: Template,
            className: "KP-snippet-composite-view",

            emptyView: NoResultsView,

            ui: {
                kpListTitle: ".separator-title-text"
            },

            initialize: function (options) {
                options = options || {};
                this.itemViewOptions = {
                    type: options.type
                };
            },

            onRender: function () {
                //this.ui.kpListTitle.text(this.options.type);
            },
            setSelected: function (slug) {
                this.children.each(function (view) {
                    view.setSelected(slug);
                });
            },
            unSelectAll: function () {
                this.children.each(function (view) {
                    if (view.unSelect) {
                        view.unSelect();
                    }
                });
            }

        });
    });

    return KPsSnippetsCompositeView;


});

